/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-extraneous-dependencies */
import { useNamespace, useOkapiKy } from '@folio/stripes-core';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

function useBarcode() {
  // const [lastIndex, setLastIndex] = useState(null);
  // const [configId, setConfigId] = useState(null);

  const okapiKy = useOkapiKy();
  const [namespace] = useNamespace({ key: 'barcodeLastIndex' });

  const {
    isLoading,
    isError,
    data = {},
    refetch,
    isFetched,
    ...rest
  } = useQuery(
    [namespace],
    () =>
      okapiKy
        .get('inventory-templates-configs?query=(configName==barcodeLastIndex)')
        .json(),
    { enabled: true },
  );

  const onCreateBarcodeLastIndexConfig = () => {
    okapiKy
      .post('inventory-templates-configs', {
        timeout: 30000,
        method: 'POST',
        json: {
          configName: 'barcodeLastIndex',
          configCode: 'barcodeLastIndex',
          configValue: {
            lastIndex: 0,
          },
        },
      })
      .then((res) => {
        if (res.totalRecords < 0) {
          console.log('Barcode last index config created successfully.');
          refetch();
        }
      })
      .catch(async (err) => {
        console.log(err);
        const res = err.response;
        const text = await res.text();
        console.log(text);
      });
  };

  useEffect(() => {
    if (!isLoading && data.totalRecords === 0) {
      onCreateBarcodeLastIndexConfig();
    }
    //  else if (!isLoading) {
    //   setLastIndex(data?.templatesConfigs[0]?.configValue?.lastIndex);
    //   setConfigId(data?.templatesConfigs[0]?.id);
    // }
  }, [data, isLoading]);

  // console.log('lastIndex: ', lastIndex);

  return {
    isLoading,
    isFetched,
    isError,
    refetch,
    rest,
    configId: !isLoading ? data?.templatesConfigs[0]?.id : undefined,
    lastIndex: !isLoading
      ? data?.templatesConfigs[0]?.configValue?.lastIndex
      : undefined,
  };
}

export default useBarcode;
